import React, { useState } from 'react'
import { Navbar, Image, Modal, Box } from 'react-bulma-components'
import { NavLink, useLocation } from 'react-router-dom'
import { BiSupport } from 'react-icons/bi'
import { useTranslations } from '../../hooks/use-translations'
import { useIsMobile } from '../../hooks/use-is-mobile'

// @ts-expect-error
import logo from '../../assets/images/logo.png'
import { Translate } from '../../utils/translations'
import { sortBy } from 'lodash'
import { GoogleTranslate } from '../google-translate/google-translate'
import { campaign } from '../../campaigns'

/**
 * Placeholder contact phone numbers per country.
 * TODO: replace with the real support numbers once provided.
 */
const CONTACT_PHONES: { country: string; phone: string }[] = [
  { country: 'France', phone: '+33 1 23 45 67 89' },
  { country: 'België / Belgique / Belgien', phone: '+32 2 123 45 67' },
  { country: 'España', phone: '+34 91 123 45 67' },
  { country: 'Italia', phone: '+39 02 1234 5678' },
  { country: 'Deutschland', phone: '+49 30 123456' },
]

export const Header: React.FC = () => {
  const location = useLocation()
  const locationWithoutLanguage = location.pathname.split('/').slice(2).join('/') + location.search
  const [showMenu, setShowMenu] = useState(false)
  const [showContactModal, setShowContactModal] = useState(false)
  const { current, all } = useTranslations()
  const isMobile = useIsMobile(600)

  const languages = sortBy(
    Object.keys(all).map(locale => ({ name: all[locale], locale })),
    'name',
  )

  // Split languages into columns for better mobile display
  const chunkSize = Math.ceil(languages.length / 3) // 3 columns max
  const languageColumns = []
  for (let i = 0; i < languages.length; i += chunkSize) {
    languageColumns.push(languages.slice(i, i + chunkSize))
  }

  return (
    <>
      <Navbar>
        <Navbar.Brand>
          <Navbar.Item renderAs={NavLink} to={`/${current}`}>
            <Image src={logo} style={{ maxHeight: 80 }} />
          </Navbar.Item>
        </Navbar.Brand>
        <Navbar.Menu>
          {/* Language selector dropdown */}
          <Navbar.Item hoverable onClick={() => setShowMenu(!showMenu)}>
            <Navbar.Link>
              <Translate value="meta.lang" />
            </Navbar.Link>
            <Navbar.Dropdown right={isMobile}>
              <div className="lang-dropdown-grid">
                {languages.map(l => {
                  return (
                    <Navbar.Item
                      renderAs={NavLink}
                      to={`/${l.locale}/${locationWithoutLanguage}`}
                      key={l.locale}
                      style={{
                        padding: '0.5rem 0.75rem',
                        fontSize: '0.9rem',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {l.name}
                    </Navbar.Item>
                  )
                })}
              </div>
              <Navbar.Divider />
              <Navbar.Item>
                <GoogleTranslate />
              </Navbar.Item>
            </Navbar.Dropdown>
          </Navbar.Item>

          {/* Phone contact button (campaign-specific), pushed to the right */}
          {campaign.hasContactButton && (
            <Navbar.Item
              className="has-text-link"
              onClick={() => setShowContactModal(true)}
              style={{ marginLeft: 'auto', cursor: 'pointer' }}
              aria-label="Contact"
            >
              <BiSupport size={22} />
            </Navbar.Item>
          )}
        </Navbar.Menu>
      </Navbar>

      {campaign.hasContactButton && (
        <Modal show={showContactModal} onClose={() => setShowContactModal(false)} closeOnEsc>
          <Modal.Content>
            <Box>
              <p className="title is-5 has-text-centered">Nous contacter</p>
              {/* Placeholder phone list: real numbers to be wired in later. */}
              <ul>
                {CONTACT_PHONES.map(({ country, phone }) => (
                  <li
                    key={country}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '0.5rem 0',
                      borderBottom: '1px solid #f0f0f0',
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>{country}</span>
                    <a href={`tel:${phone.replace(/\s/g, '')}`} className="has-text-link">
                      {phone}
                    </a>
                  </li>
                ))}
              </ul>
            </Box>
          </Modal.Content>
        </Modal>
      )}
    </>
  )
}
